export function getAccesslogsRoutes() {
  return [
    {
      path: "/accesslogs",
      name: "accesslogs",
      component: () => import(/* webpackChunkName: accesslogs-old-backend */ "./components/AccesslogsOld.vue"),
    },
  ]
}
